import { render, staticRenderFns } from "./EmploymentContractView.vue?vue&type=template&id=235c833b"
import script from "./EmploymentContractView.vue?vue&type=script&lang=js"
export * from "./EmploymentContractView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports